/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable no-useless-escape */
import React from 'react'

const Form: React.FC<{ id: string }> = ({ id }) => (
  <div
    id={id}
    {...{ 'data-name': 'Unified' }}
    dangerouslySetInnerHTML={{
      __html: `
      <form id="localAccountForm" action="JavaScript:void(0);" class="localAccount" aria-label="Sign in with your email address" data-bitwarden-watching="1" data-bitwarden-processed="0">
        <div class="intro">
          <h2 aria-level="1">
            Sign in with your email address
          </h2>
        </div>
        <div class="error pageLevel" aria-hidden="false" role="alert" style="display: block;">
          <p>Basic credentials specified for 'UserMigration-AfterFailedSignInAttempt' are invalid. Check that the credentials are correct and that access has been granted by the resource.</p>
        </div>
        <div class="entry">
          <div class="entry-item">
            <label for="signInName">
              Email Address
            </label>
            <div class="error itemLevel" aria-hidden="true" role="alert" style="display: none;">
              <p></p>
            </div>
            <input type="email" id="signInName" name="Email Address" title="Please enter a valid Email Address" pattern="^[a-zA-Z0-9.!#$%&amp;amp;&amp;#39;^_\`{}~+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" autofocus="" placeholder="Email Address" value="" aria-label="Email Address">
          </div>
            <div class="entry-item">
              <div class="password-label">
                <label for="password">Password</label>
                    <a id="forgotPassword" href="/phillipsauthqa.onmicrosoft.com/B2C_1A_SignUpOrSignIn/api/CombinedSigninAndSignup/forgotPassword?csrf_token=QzZvSklsNHZSZVdCa080NkxrNnhIMm9CMEoxVU1CR1ZscWJmVkRqSlN5UEVKOFRxS01VM0FyeFFSL0VIbjJHQjRuTGpuaERvUVVIRUUzY2l0aHpGZVE9PTsyMDIzLTA2LTIxVDEzOjE4OjIzLjA3NTg2NjNaO1VLOHFmZDUvbGRpa1RrU24ySFU2RUE9PTt7Ik9yY2hlc3RyYXRpb25TdGVwIjoxfQ==&amp;tx=StateProperties=eyJUSUQiOiJmNDkxMjM3Yy1lNjM0LTQ0OWItODdmNS1jODU5NWIzMzdiYjQifQ&amp;p=B2C_1A_SignUpOrSignIn">Forgot your password?</a>
                              </div>
              <div class="error itemLevel" aria-hidden="true" style="display: none;">
                <p role="alert"></p>
              </div>
              <input type="password" id="password" name="Password" placeholder="Password" aria-label="Password" autocomplete="current-password" aria-required="true">
                          </div>
          <div class="working" style="display: none;"></div>


          <div class="buttons">
            <button id="next" type="submit" form="localAccountForm" data-bitwarden-clicked="1">Sign in</button>
          </div>
        </div>
              <div class="divider">
                <h2>OR</h2>
              </div>
              <div class="create">
                <p>
                  Don't have an account?<a id="createAccount" href="/phillipsauthqa.onmicrosoft.com/B2C_1A_SignUpOrSignIn/api/CombinedSigninAndSignup/unified?local=signup&amp;csrf_token=QzZvSklsNHZSZVdCa080NkxrNnhIMm9CMEoxVU1CR1ZscWJmVkRqSlN5UEVKOFRxS01VM0FyeFFSL0VIbjJHQjRuTGpuaERvUVVIRUUzY2l0aHpGZVE9PTsyMDIzLTA2LTIxVDEzOjE4OjIzLjA3NTg2NjNaO1VLOHFmZDUvbGRpa1RrU24ySFU2RUE9PTt7Ik9yY2hlc3RyYXRpb25TdGVwIjoxfQ==&amp;tx=StateProperties=eyJUSUQiOiJmNDkxMjM3Yy1lNjM0LTQ0OWItODdmNS1jODU5NWIzMzdiYjQifQ&amp;p=B2C_1A_SignUpOrSignIn">Sign up now</a>
                </p>
              </div>
      </form>
  `,
    }}
  />
)

export default Form
